import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=0ffb7dbc&scoped=true"
import script from "./FieldSelector.vue?vue&type=script&lang=js"
export * from "./FieldSelector.vue?vue&type=script&lang=js"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=0ffb7dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb7dbc",
  null
  
)

export default component.exports